(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fd-course-menu"]) return;
  try {
    
  (function () {
    if (window.__fdCourseMenu) return;
    window.__fdCourseMenu = true;
    var PATH = '/pages/corso-di-fotografia';
    var pending = null;
    function make(cls) {
      var a = document.createElement('a');
      a.className = 'fd-news ' + cls;
      a.href = PATH;
      a.innerHTML = '<span>Corso di fotografia</span><span class="fd-news__tag">Novità</span>';
      return a;
    }
    function inMenu(root) {
      return !!root.querySelector('a[href*="corso-di-fotografia"]:not(.fd-news)');
    }
    function run() {
      pending = null;
      var inner = document.querySelector('header-menu .header-menu__inner');
      if (inner && !inner.querySelector('.fd-news') && !inMenu(inner)) {
        inner.appendChild(make('fd-news--desktop'));
      }
      var list = document.querySelector('.menu-drawer__menu');
      if (list && !list.querySelector('.fd-news') && !inMenu(list)) {
        var li = document.createElement('li');
        li.className = 'fd-news-li';
        li.appendChild(make('fd-news--drawer'));
        list.appendChild(li);
      }
    }
    function schedule() {
      if (pending) return;
      pending = setTimeout(run, 50);
    }
    function start() {
      run();
      new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
    window.addEventListener('pageshow', schedule);
    document.addEventListener('shopify:section:load', schedule);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fd-hero-slides"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('fd-hero-slides')) {
customElements.define(
'fd-hero-slides',
class FdHeroSlides extends HTMLElement {
connectedCallback() {
this.viewport = this.querySelector('[data-fd-viewport]');
this.slides = Array.from(this.querySelectorAll('[data-fd-slide]'));
this.dots = Array.from(this.querySelectorAll('[data-fd-dot]'));
this.toggle = this.querySelector('[data-fd-toggle]');
this.index = 0;
this.timer = null;
this.hovered = false;
this.focused = false;
this.visible = true;
this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
this.delay = Math.max(3000, parseInt(this.dataset.interval, 10) || 6000);
const inEditor = Boolean(window.Shopify && window.Shopify.designMode);
this.userPaused = this.dataset.autoplay !== 'true' || this.reduceMotion || inEditor;
this.armed = inEditor;
if (inEditor) {
this.hydrate();
} else {
const arm = () => {
setTimeout(() => this.hydrate(), 3000);
setTimeout(() => {
this.armed = true;
this.sync();
}, 10000);
};
if (document.readyState === 'complete') arm();
else window.addEventListener('load', arm, { once: true });
}
if (this.slides.length < 2) return;
const prev = this.querySelector('[data-fd-prev]');
const next = this.querySelector('[data-fd-next]');
if (prev) prev.addEventListener('click', () => this.goTo(this.index - 1));
if (next) next.addEventListener('click', () => this.goTo(this.index + 1));
this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.goTo(i)));
if (this.toggle) {
this.toggle.addEventListener('click', () => {
this.userPaused = !this.userPaused;
this.sync();
});
}
this.addEventListener('pointerenter', (e) => {
this.hydrate();
if (e.pointerType === 'mouse') {
this.hovered = true;
this.sync();
}
});
this.addEventListener('pointerleave', (e) => {
if (e.pointerType === 'mouse') {
this.hovered = false;
this.sync();
}
});
this.addEventListener('focusin', () => {
this.hydrate();
this.focused = true;
this.sync();
});
this.addEventListener('focusout', () => {
this.focused = false;
this.sync();
});
this.addEventListener('keydown', (e) => {
if (e.key === 'ArrowLeft') this.goTo(this.index - 1);
if (e.key === 'ArrowRight') this.goTo(this.index + 1);
});
this.onVisibility = () => this.sync();
document.addEventListener('visibilitychange', this.onVisibility);
if ('IntersectionObserver' in window) {
this.observer = new IntersectionObserver(
(entries) => {
this.visible = entries[0].isIntersecting;
this.sync();
},
{ threshold: 0.25 }
);
this.observer.observe(this);
}
this.bindSwipe();
this.addEventListener('shopify:block:select', (e) => {
const i = this.slides.findIndex((slide) => slide.contains(e.target));
if (i > -1) this.goTo(i);
});
this.sync();
}
disconnectedCallback() {
clearTimeout(this.timer);
if (this.observer) this.observer.disconnect();
if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
}
hydrate() {
this.querySelectorAll('template[data-fd-lazy]').forEach((t) => t.replaceWith(t.content));
}
bindSwipe() {
let startX = 0;
let startY = 0;
let tracking = false;
let moved = false;
this.viewport.addEventListener('pointerdown', (e) => {
this.hydrate();
if (e.pointerType === 'mouse' && e.button !== 0) return;
tracking = true;
moved = false;
startX = e.clientX;
startY = e.clientY;
});
this.viewport.addEventListener('pointerup', (e) => {
if (!tracking) return;
tracking = false;
const dx = e.clientX - startX;
const dy = e.clientY - startY;
if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) {
moved = true;
this.goTo(this.index + (dx < 0 ? 1 : -1));
}
});
this.viewport.addEventListener('pointercancel', () => {
tracking = false;
});
this.viewport.addEventListener(
'click',
(e) => {
if (moved) {
e.preventDefault();
e.stopPropagation();
moved = false;
}
},
true
);
}
goTo(target) {
this.hydrate();
const count = this.slides.length;
this.index = ((target % count) + count) % count;
this.slides.forEach((slide, i) => {
const active = i === this.index;
slide.classList.toggle('is-active', active);
slide.toggleAttribute('inert', !active);
if (active) slide.removeAttribute('aria-hidden');
else slide.setAttribute('aria-hidden', 'true');
const link = slide.querySelector('a.fd-hero__link');
if (link) {
if (active) link.removeAttribute('tabindex');
else link.setAttribute('tabindex', '-1');
}
});
this.dots.forEach((dot, i) => {
if (i === this.index) dot.setAttribute('aria-current', 'true');
else dot.removeAttribute('aria-current');
});
this.sync();
}
get playing() {
return this.armed && !this.userPaused && !this.hovered && !this.focused && this.visible && !document.hidden;
}
sync() {
clearTimeout(this.timer);
this.classList.remove('is-running');
if (this.toggle) {
const pause = this.toggle.querySelector('.fd-hero__icon-pause');
const play = this.toggle.querySelector('.fd-hero__icon-play');
if (pause) pause.hidden = this.userPaused;
if (play) play.hidden = !this.userPaused;
this.toggle.setAttribute(
'aria-label',
this.userPaused ? 'Riprendi lo scorrimento' : 'Metti in pausa lo scorrimento'
);
}
this.viewport.setAttribute('aria-live', this.userPaused ? 'polite' : 'off');
if (!this.playing) return;
void this.offsetWidth;
this.classList.add('is-running');
this.timer = setTimeout(() => this.goTo(this.index + 1), this.delay);
}
}
);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fd-menu-styles"]) return;
  try {
    
  /* Menu a tendina su PC: dopo un clic su una voce (es. Usato) il tema la tiene attiva finche' non si clicca altrove. Quando il mouse esce dalla voce e dal suo menu, tolgo il focus cosi' il menu si chiude. */
  (function () {
    if (window.__fdMenuAutoClose) return;
    window.__fdMenuAutoClose = true;
    document.addEventListener('mouseout', function (e) {
      var target = e.target;
      if (!target || !target.closest) return;
      var item = target.closest('.menu-list__list-item');
      if (!item) return;
      if (e.relatedTarget && item.contains(e.relatedTarget)) return;
      setTimeout(function () {
        if (item.matches(':hover')) return;
        var active = document.activeElement;
        if (active && item.contains(active) && active.blur) active.blur();
      }, 250);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fd-product-carousel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('fd-products')) {
customElements.define(
'fd-products',
class FdProducts extends HTMLElement {
connectedCallback() {
this.track = this.querySelector('[data-fd-track]');
this.items = Array.from(this.querySelectorAll('[data-fd-item]'));
this.prev = this.querySelector('[data-fd-prev]');
this.next = this.querySelector('[data-fd-next]');
this.current = this.querySelector('[data-fd-current]');
this.index = 0;
if (!this.track || this.items.length === 0) return;
this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
this.onScroll = () => {
if (this.frame) return;
this.frame = requestAnimationFrame(() => {
this.frame = 0;
this.sync(Math.round(this.track.scrollLeft / (this.track.clientWidth || 1)));
});
};
this.track.addEventListener('scroll', this.onScroll, { passive: true });
if (this.prev) this.prev.addEventListener('click', () => this.goTo(this.index - 1));
if (this.next) this.next.addEventListener('click', () => this.goTo(this.index + 1));
this.addEventListener('keydown', (e) => {
if (e.key === 'ArrowLeft') this.goTo(this.index - 1);
if (e.key === 'ArrowRight') this.goTo(this.index + 1);
});
this.addEventListener('shopify:block:select', (e) => {
const i = this.items.findIndex((item) => item.contains(e.target));
if (i > -1) this.goTo(i);
});
if ('ResizeObserver' in window) {
this.resizeObserver = new ResizeObserver(() => {
this.track.scrollTo({ left: this.index * this.track.clientWidth, behavior: 'auto' });
});
this.resizeObserver.observe(this.track);
}
this.sync(0);
}
disconnectedCallback() {
if (this.resizeObserver) this.resizeObserver.disconnect();
if (this.track && this.onScroll) this.track.removeEventListener('scroll', this.onScroll);
if (this.frame) cancelAnimationFrame(this.frame);
}
goTo(target) {
const count = this.items.length;
const i = ((target % count) + count) % count;
this.track.scrollTo({
left: i * this.track.clientWidth,
behavior: this.reduceMotion ? 'auto' : 'smooth',
});
}
sync(i) {
const count = this.items.length;
this.index = Math.min(Math.max(i, 0), count - 1);
if (this.current) this.current.textContent = String(this.index + 1);
this.items.forEach((item, n) => {
const active = n === this.index;
item.toggleAttribute('inert', !active);
if (active) item.removeAttribute('aria-hidden');
else item.setAttribute('aria-hidden', 'true');
});
}
}
);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fd-promo-cards"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fd-promos')) {
    customElements.define(
      'fd-promos',
      class FdPromos extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-fd-track]');
          this.nav = this.querySelector('[data-fd-nav]');
          this.prev = this.querySelector('[data-fd-prev]');
          this.next = this.querySelector('[data-fd-next]');
          if (!this.track) return;

          this.onScroll = () => this.update();
          this.track.addEventListener('scroll', this.onScroll, { passive: true });
          if (this.prev) this.prev.addEventListener('click', () => this.step(-1));
          if (this.next) this.next.addEventListener('click', () => this.step(1));

          if ('ResizeObserver' in window) {
            this.resizeObserver = new ResizeObserver(this.onScroll);
            this.resizeObserver.observe(this.track);
          }
          this.update();
        }

        disconnectedCallback() {
          if (this.resizeObserver) this.resizeObserver.disconnect();
          if (this.track && this.onScroll) this.track.removeEventListener('scroll', this.onScroll);
        }

        step(direction) {
          const item = this.track.querySelector('.fd-promos__item');
          if (!item) return;
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.track.scrollBy({
            left: direction * (item.getBoundingClientRect().width + gap),
            behavior: reduceMotion ? 'auto' : 'smooth',
          });
        }

        update() {
          const track = this.track;
          const max = track.scrollWidth - track.clientWidth;
          if (this.nav) this.nav.hidden = max <= 2;
          if (this.prev) this.prev.disabled = track.scrollLeft <= 2;
          if (this.next) this.next.disabled = track.scrollLeft >= max - 2;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
